export default {
    header: "Viewnotfound",
    view: "Viewnotfound"
};